document.addEventListener('DOMContentLoaded', function () {
  // Flag to track when adding from order now page
  let isAddingFromOrderNow = false;

  // Get cart type setting (drawer or page)
  const cartType = window.cartType || 'drawer';

  // Intercept theme's cart:added event to handle based on cart type setting
  document.addEventListener('theme:cart:added', function(e) {
    if (isAddingFromOrderNow) {
      // If cart type is 'page', redirect to cart page
      if (cartType === 'page') {
        e.stopImmediatePropagation(); // Prevent any drawer behavior
        window.location = '/cart';
      }
      // If cart type is 'drawer', let theme's default drawer behavior happen
      // (no action needed - theme will open drawer automatically)
    }
  }, true); // Use capture phase to intercept before theme's handler

  // Retrieve product JSONs from the Liquid script
  let currentMonthProduct = window.currentMonthProduct;
  let nextMonthProduct = window.nextMonthProduct;
  let currentMonthSeasonalProduct = window.currentMonthSeasonalProduct;
  let nextMonthSeasonalProduct = window.nextMonthSeasonalProduct;
  let currentMonthProductDefault = window.currentMonthProductDefault;
  let nextMonthProductDefault = window.nextMonthProductDefault;

  // Log the product JSONs to the console
  console.log('Current Month Product JSON:', currentMonthProduct);
  console.log('Next Month Product JSON:', nextMonthProduct);
  console.log('Current Month Seasonal Product JSON:', currentMonthSeasonalProduct);
  console.log('Next Month Seasonal Product JSON:', nextMonthSeasonalProduct);

  let selectedProductId = null;
  let selectedMenuOption = null;
  let selectedVariant = null;
  let infoOpened = false;

  const orderNowSection = document.getElementById('order-now-section');
  const progressBarContainer = document.querySelector('.order-progress-bar-container');
  const productPart = document.getElementById('product-part');
  const cartPart = document.getElementById('cart-part');
  const cartContents = document.getElementById('cart-contents');
  let menuOptions = document.getElementById('menu-options');
  let sizeOptions = document.getElementById('size-options');
  let progressBarSteps = document.querySelectorAll('.order-progress-step');
  let addToCartForm = document.getElementById('order-now-form');
  let addToCartButton = document.getElementById('order-now-add-to-cart');
  let frequencyLabel = document.getElementById('frequency-label');
  let frequencySubheading = document.getElementById('frequency-subheading');
  let orderNowFormSubscription = document.getElementById('order-now-form-subscription');

  orderNowFormSubscription.addEventListener('click', function () {
    // Check if the clicked element is an input
    updateProgressBar(3);
  });

  // Function to initialize the page
  function initializePage() {
    let initialProduct = currentMonthProduct;
    let initialSeasonalProduct = currentMonthSeasonalProduct;
    let month = 'current';
    if (nextMonthProductDefault) {
      initialProduct = nextMonthProduct;
      initialSeasonalProduct = nextMonthSeasonalProduct;
      month = 'next';
    }
    if (currentMonthProductDefault) {
      initialProduct = currentMonthProduct;
      initialSeasonalProduct = currentMonthSeasonalProduct;
    }
    // Populate the menu selector and display variants
    populateMenuSelector(initialProduct, initialSeasonalProduct, month);
    displayVariants(initialProduct.id, initialProduct ? initialProduct.variants[0].option1 : '');
    updateProgressBar(1);
    updateFrequencyLabel(initialProduct);

    addToCartForm.addEventListener('submit', handleAddToCart);

    document.querySelectorAll('.cart__item__remove').forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        const lineItemId = button.getAttribute('data-id');
        removeCartItem(lineItemId);
      });
    });

    if (!currentMonthProductDefault && nextMonthProductDefault) {
      document.getElementById('current-month-btn').classList.remove('active');
      document.getElementById('next-month-btn').classList.add('active');
    }
  }

  function toggleMenuInfoShow(activeId) {
    // const textIds = [
    //   'current-family-style',
    //   'current-gluten-free',
    //   'current-macro-balanced',
    //   'current-soup-menu',
    //   'next-family-style',
    //   'next-gluten-free',
    //   'next-macro-balanced',
    //   'next-soup-menu',
    // ];

    let menuContentGridRow = 0;
    const menuOptionCard = document.querySelector(`.${activeId}-card`);

    // if (!(menuOptionCard.classList.contains('active') || infoOpened === true)) {
    //   return;
    // }

    // if (menuOptionCard.classList.contains('info-opened')) {
    //   menuOptionCard.classList.remove('info-opened');
    //   hideMenuDetails();
    //   infoOpened = false;
    //   return;
    // } else {
    // const menuOptions = document.getElementById('menu-options');
    // if (menuOptions) {
    //   const cards = menuOptions.querySelectorAll('.menu-option-card');
    //   cards.forEach((card) => {
    //     card.classList.remove('info-opened');
    //   });
    // }
    // menuOptionCard.classList.add('info-opened');
    const index = Array.from(menuOptionCard.parentNode.children).indexOf(menuOptionCard);
    menuContentGridRow = Math.floor(index / 2) + 2;
    // }

    // infoOpened = true;
    showMenuDetails(activeId, menuContentGridRow);
  }

  function showMenuDetails(id, gridRowStart) {
    hideMenuDetails();
    const original = document.querySelector(`.menu-details-placeholder #${id}.text`);
    if (!original) return;

    const copy = original.cloneNode(true); // Deep copy

    const container = document.createElement('div');
    container.className = 'menu-details-container';
    container.style.gridRowStart = gridRowStart;

    const menuOptions = document.getElementById('menu-options');
    if (!menuOptions) return;

    container.appendChild(copy);
    menuOptions.appendChild(container);
  }

  function hideMenuDetails() {
    const container = document.querySelector(`.menu-details-container`);
    if (container) {
      container.remove();
    }
  }

  function populateMenuSelector(product, seasonalProduct, month) {
    menuOptions.innerHTML = '';
    let uniqueOptions1 = [];
    let firstMenuCard = true;
    (product.variants || []).forEach(function (variant) {
      if (!uniqueOptions1.includes(variant.option1)) {
        uniqueOptions1.push(variant.option1);

        // Create the card container
        let menuCard = document.createElement('div');
        menuCard.classList.add('menu-option-card');

        menuCard.innerHTML = `
          <svg class="svg" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10.5" cy="10.5" r="10" fill="#FBD401" stroke="black"/>
            <path d="M5.97168 11.4451L9.50002 14.7609L14.8138 6.47144" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `;

        // Create view menu button element
        const textId = `${month}-${variant.option1.toLowerCase().replace(' ', '-')}`;

        // Create image element
        let img = document.createElement('img');
        img.src = variant.featured_image ? variant.featured_image.src : '';
        img.alt = variant.option1;

        // Create overlay element
        let overlay = document.createElement('div');
        overlay.classList.add('overlay');

        // Create text element
        let span = document.createElement('span');
        span.textContent = variant.option1;

        // Append image and text to the card
        menuCard.appendChild(img);
        menuCard.appendChild(overlay);
        menuCard.appendChild(span);
        menuCard.setAttribute('data-option1', variant.option1);
        menuCard.classList.add(`${textId}-card`);

        if (firstMenuCard) {
          menuCard.classList.add('active');
          firstMenuCard = false; // Ensure this only happens for the first card

          const firstTextId = textId;

          setTimeout(() => {
            toggleMenuInfoShow(firstTextId);
          }, 0);
        }

        menuCard.addEventListener('click', function () {
          // On menu change, update selectedMenuOption and refresh variants

          toggleMenuInfoShow(textId);
          removeActiveClass('menu-option-card');
          menuCard.classList.add('active');
          const prevSelectedProductId = selectedProductId;
          displayVariants(product.id, variant.option1);
          if (prevSelectedProductId !== product.id) {
            initYotpoWidget(product);
            updateFrequencyLabel(product);
          }
          updateProgressBar(1); // Move to step 2 on menu selection
        });

        menuOptions.appendChild(menuCard);
      }
    });
    if (seasonalProduct && seasonalProduct.id) {
      // Create the card container
      let menuCard = document.createElement('div');
      menuCard.classList.add('menu-option-card');

      menuCard.innerHTML = `
        <svg class="svg" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10.5" cy="10.5" r="10" fill="#FBD401" stroke="black"/>
          <path d="M5.97168 11.4451L9.50002 14.7609L14.8138 6.47144" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;

      // Create info icon element
      const textId = `${month}-soup-menu`;

      // Create image element
      let img = document.createElement('img');
      img.src = seasonalProduct.featured_image ? seasonalProduct.featured_image : '';
      img.alt = seasonalProduct.title;

      // Create overlay element
      let overlay = document.createElement('div');
      overlay.classList.add('overlay');

      // Create text element
      let span = document.createElement('span');
      span.textContent = seasonalProduct.title;

      // Append image and text to the card
      menuCard.appendChild(img);
      menuCard.appendChild(overlay);
      menuCard.appendChild(span);
      menuCard.setAttribute('data-option1', seasonalProduct.title);
      menuCard.classList.add(`${textId}-card`);

      menuCard.addEventListener('click', function () {
        // On menu change, update selectedMenuOption and refresh variants

        toggleMenuInfoShow(textId);
        removeActiveClass('menu-option-card');
        menuCard.classList.add('active');
        displaySizeVariants(seasonalProduct.id);
        updateFrequencyLabel(seasonalProduct);
        updateProgressBar(1); // Move to step 2 on menu selection

        // Remove the yotpo subscription widget
        let widgetContainer = document.getElementById('order-now-form-subscription');
        widgetContainer.innerHTML = '';
      });

      menuOptions.appendChild(menuCard);
    }
  }

  // Function to display variants based on selected product and menu option
  function displayVariants(productId, menuOption) {
    // Only proceed if we have new product/menu selection
    if (selectedProductId !== productId || selectedMenuOption !== menuOption) {
      selectedProductId = productId;
      selectedMenuOption = menuOption;

      // Clear previous size options
      sizeOptions.innerHTML = '';

      // Get the correct product (current or next month)
      const product = selectedProductId === currentMonthProduct.id ? currentMonthProduct : nextMonthProduct;

      // Filter variants for the selected menu option
      const matchedVariants = (product.variants || []).filter((variant) => {
        return variant.option1 === menuOption;
      });

      if (matchedVariants.length > 0) {
        // Select first variant by default
        selectedVariant = matchedVariants[0];

        // Create size option cards for each variant
        matchedVariants.forEach((variant, index) => {
          // Extract serving range (e.g., "3-4" from "3-4 Servings")
          const servingsMatch = variant.option2.match(/(\d+)\s*-\s*(\d+)/i);
          const servingsText = servingsMatch ? `${servingsMatch[1]}-${servingsMatch[2]} servings` : variant.option2;

          // Calculate price per serving
          const pricePerServing = servingsMatch
            ? (variant.price / 100 / parseInt(servingsMatch[2])).toFixed(2)
            : (variant.price / 100).toFixed(2);

          // Create size option card
          const sizeCard = document.createElement('div');
          sizeCard.className = 'size-option-card';
          sizeCard.innerHTML = `
            <h4>${getSizeTitle(variant.option2)}</h4>
            <p>${servingsText}<br>Starts at $${pricePerServing}/serving</p>
          `;

          // Set first card as active by default
          if (index === 0) {
            sizeCard.classList.add('active');
            updateServingsInfo(servingsText);
          }

          // Handle card selection
          sizeCard.addEventListener('click', () => {
            selectedVariant = variant;

            // Update UI
            document.querySelectorAll('.size-option-card').forEach((c) => {
              c.classList.remove('active');
            });
            sizeCard.classList.add('active');
            updateServingsInfo(servingsText);
            updateAddToCartButtonState(variant.available);
            updateProgressBar(2);
            updateYotpoWidget(variant);
          });

          sizeOptions.appendChild(sizeCard);
        });

        // Initialize button and widget states
        updateAddToCartButtonState(matchedVariants[0].available);
        updateYotpoWidget(matchedVariants[0]);
      }
    }
  }

  // Helper function to get display title based on variant option
  function getSizeTitle(optionText) {
    if (optionText.includes('Smaller')) return 'Smaller portions';
    if (optionText.includes('Regular')) return 'Regular';
    if (optionText.includes('Larger')) return 'Larger portions';
    return optionText;
  }

  // Helper function to update servings info text
  function updateServingsInfo(servingsText) {
    const servingsInfo = document.getElementById('servings-info');
    if (servingsInfo) {
      servingsInfo.textContent = `You will receive ${servingsText} of each freezer meal on the menu.`;
      servingsInfo.style.display = 'block';
    }
  }

  // Function to display size variants initially without menu option
  function displayVariants(productId, menuOption) {
    if (selectedProductId !== productId || selectedMenuOption !== menuOption) {
      selectedProductId = productId;
      selectedMenuOption = menuOption;

      sizeOptions.innerHTML = '';
      const product = selectedProductId === currentMonthProduct.id ? currentMonthProduct : nextMonthProduct;

      const matchedVariants = (product.variants || []).filter((variant) => {
        return variant.option1 === menuOption;
      });

      if (matchedVariants.length > 0) {
        selectedVariant = matchedVariants[0];

        matchedVariants.forEach((variant, index) => {
          const servingsMatch = variant.option2.match(/(\d+)\s*-\s*(\d+)/i);
          const servingsText = servingsMatch ? `${servingsMatch[1]}-${servingsMatch[2]} servings` : variant.option2;

          const pricePerServing = servingsMatch
            ? (variant.price / 100 / parseInt(servingsMatch[2])).toFixed(2)
            : (variant.price / 100).toFixed(2);

          // Create size card
          const sizeCard = document.createElement('div');
          sizeCard.className = 'size-option-card';

          // Create radio, title and price container
          const radioTitleContainer = document.createElement('div');
          radioTitleContainer.className = 'radio-title-container';
          radioTitleContainer.innerHTML = `
            <input type="radio" name="size-option" id="size-${variant.id}" value="${variant.id}" ${
            index === 0 ? 'checked' : ''
          }>
            <label for="size-${variant.id}" class="custom-radio"></label>
            <div class="title-price-wrapper">
              <span class="cerebri-regular">${getSizeTitle(variant.option2)}</span>
              <div class="servings-price-container">
                <p class="servings-text yotpo-subscription-policy-text-main cerebri-regular">${servingsText}</p>
                <p class="price-text yotpo-subscription-policy-text-main cerebri-regular">Starts at $${pricePerServing}/serving</p>
              </div>
            </div>
          `;

          sizeCard.appendChild(radioTitleContainer);

          if (index === 0) {
            sizeCard.classList.add('active');
            // Add serving note for initially selected variant
            const note = document.createElement('div');
            note.className = 'serving-note , cerebris_font';
            note.textContent = `You will receive ${servingsText} of each freezer meal on the menu.`;
            sizeCard.appendChild(note);
          }

          sizeCard.addEventListener('click', () => {
            selectedVariant = variant;
            document.querySelectorAll('.size-option-card').forEach((c) => {
              c.classList.remove('active');
              c.querySelector('.serving-note')?.remove();
            });

            sizeCard.classList.add('active');
            const note = document.createElement('div');
            note.className = 'serving-note';
            note.textContent = `You will receive ${servingsText} of each freezer meal on the menu.`;
            sizeCard.appendChild(note);

            updateAddToCartButtonState(variant.available);
            updateProgressBar(2);
            updateYotpoWidget(variant);
          });

          sizeOptions.appendChild(sizeCard);
        });

        updateAddToCartButtonState(matchedVariants[0].available);
        updateYotpoWidget(matchedVariants[0]);
      }
    }
  }

  // // Function to display size variants initially without menu option
  // function displaySizeVariants(productId) {
  //   // Check if selected product or menu option has changed
  //   if (selectedProductId !== productId) {
  //     selectedProductId = productId;

  //     sizeOptions.innerHTML = ''; // Clear previous size options
  //     let product =
  //       selectedProductId === currentMonthSeasonalProduct.id ? currentMonthSeasonalProduct : nextMonthSeasonalProduct;
  //     selectedMenuOption = product.title;
  //     const variants = product.variants || [];
  //     let firstSizeCard = true;
  //     if (variants.length > 0) {
  //       selectedVariant = variants[0]; // Select the first variant by default

  //       variants.forEach(function (variant) {
  //         let sizeCard = document.createElement('label');
  //         sizeCard.classList.add('size-option-card');
  //         sizeCard.setAttribute('for', `size-${variant.id}`);
  //         if (firstSizeCard) {
  //           sizeCard.classList.add('active');
  //           firstSizeCard = false; // Ensure this only happens for the first card
  //         }

  //         let radioInput = document.createElement('input');
  //         radioInput.type = 'radio';
  //         radioInput.name = 'size-option';
  //         radioInput.id = `size-${variant.id}`;
  //         radioInput.value = variant.id;
  //         radioInput.checked = selectedVariant.id === variant.id; // Default check for first variant

  //         let sizeLabel = document.createElement('span');
  //         // sizeLabel.textContent = variant.option1;
  //         sizeLabel.textContent =
  //           variant.option1 === 'Default Title' && defaultTitleReplace ? defaultTitleReplace : variant.option1;

  //         let inputWrapper = document.createElement('div');

  //         let priceWrapper = document.createElement('div');
  //         let price = document.createElement('span');
  //         price.textContent = `$${(variant.price / 100).toFixed(2)}`;
  //         priceWrapper.appendChild(price);
  //         if (variant.compare_at_price) {
  //           // Add compare at price conditionally
  //           let compareAtPrice = document.createElement('span');
  //           compareAtPrice.textContent = `($${(variant.compare_at_price / 100).toFixed(2)})`;
  //           compareAtPrice.style.textDecoration = 'line-through';
  //           compareAtPrice.style.color = '#888';
  //           compareAtPrice.style.marginLeft = '5px';
  //           priceWrapper.appendChild(compareAtPrice);
  //         }

  //         // Handle clicking on the card to select the variant
  //         radioInput.addEventListener('change', function () {
  //           selectedVariant = variant;
  //           // console.log('Selected Variant ID:', selectedVariant, variant);
  //           removeActiveClass('size-option-card');
  //           sizeCard.classList.add('active');
  //           updateAddToCartButtonState(variant.available);
  //           updateProgressBar(2); // Move to step 3 on size selection
  //           updateYotpoWidget(variant);
  //         });

  //         inputWrapper.appendChild(radioInput);
  //         inputWrapper.appendChild(sizeLabel);
  //         sizeCard.appendChild(inputWrapper);
  //         if (product.selling_plan_groups.length === 0) {
  //           sizeCard.appendChild(priceWrapper);
  //         }
  //         sizeOptions.appendChild(sizeCard);
  //       });

  //       // console.log('Default Selected Variant ID:', selectedVariant, variants[0]);
  //       updateAddToCartButtonState(variants[0].available); // Set initial state based on the first variant
  //       updateYotpoWidget(variants[0]); // Initialize Yotpo widget
  //     }
  //   }
  // }

  function getSizeTitle(optionText) {
    if (optionText.includes('Smaller')) return 'Smaller portions';
    if (optionText.includes('Regular')) return 'Regular';
    if (optionText.includes('Larger')) return 'Larger portions';
    return optionText;
  }

  function displaySizeVariants(productId) {
    if (selectedProductId !== productId) {
      selectedProductId = productId;

      sizeOptions.innerHTML = '';
      let product =
        selectedProductId === currentMonthSeasonalProduct.id ? currentMonthSeasonalProduct : nextMonthSeasonalProduct;

      const matchedVariants = product.variants || [];

      if (matchedVariants.length > 0) {
        selectedVariant = matchedVariants[0];

        matchedVariants.forEach((variant, index) => {
          // Create size card
          const sizeCard = document.createElement('div');
          sizeCard.className = 'size-option-card';

          const titleContent =
            variant.option1 === 'Default Title' && defaultTitleReplace ? defaultTitleReplace : variant.option1;

          // Create radio, title and price container
          const radioTitleContainer = document.createElement('div');
          radioTitleContainer.className = 'radio-title-container';
          radioTitleContainer.innerHTML = `
            <input type="radio" name="size-option" id="size-${variant.id}" value="${variant.id}" ${
            index === 0 ? 'checked' : ''
          }>
            <label for="size-${variant.id}" class="custom-radio"></label>
            <div class="title-price-wrapper">
              <span class="cerebri-regular">${titleContent}</span>
            </div>
          `;

          let priceWrapper = document.createElement('div');
          let price = document.createElement('p');
          price.textContent = `$${(variant.price / 100).toFixed(2)}`;
          priceWrapper.appendChild(price);
          if (variant.compare_at_price) {
            // Add compare at price conditionally
            let compareAtPrice = document.createElement('p');
            compareAtPrice.textContent = `($${(variant.compare_at_price / 100).toFixed(2)})`;
            compareAtPrice.style.textDecoration = 'line-through';
            compareAtPrice.style.color = '#888';
            compareAtPrice.style.marginLeft = '5px';
            priceWrapper.appendChild(compareAtPrice);
          }
          priceWrapper.classList.add('price-text');
          priceWrapper.classList.add('yotpo-subscription-policy-text-main');
          priceWrapper.classList.add('cerebri-regular');

          let priceContainer = document.createElement('div');
          priceContainer.classList.add('servings-price-container');
          priceContainer.appendChild(priceWrapper);

          sizeCard.appendChild(radioTitleContainer);
          if (product.selling_plan_groups.length === 0) {
            const wrapper = sizeCard.querySelector('.title-price-wrapper');
            if (wrapper) {
              wrapper.appendChild(priceContainer);
            }
          }

          if (index === 0) {
            sizeCard.classList.add('active');
          }

          sizeCard.addEventListener('click', () => {
            selectedVariant = variant;
            document.querySelectorAll('.size-option-card').forEach((c) => {
              c.classList.remove('active');
            });

            sizeCard.classList.add('active');

            updateAddToCartButtonState(variant.available);
            updateProgressBar(2);
            updateYotpoWidget(variant);
          });

          sizeOptions.appendChild(sizeCard);
        });

        updateAddToCartButtonState(matchedVariants[0].available);
        updateYotpoWidget(matchedVariants[0]);
      }
    }
  }

  // Function to remove the active class from all elements of a given class
  function removeActiveClass(className) {
    let elements = document.getElementsByClassName(className);
    Array.from(elements).forEach(function (element) {
      element.classList.remove('active');
    });
  }

  // Function to update the "Add to Cart" button state based on variant availability
  function updateAddToCartButtonState(isAvailable) {
    if (isAvailable) {
      addToCartButton.disabled = false;
      addToCartButton.innerText = 'Add to cart';
    } else {
      addToCartButton.disabled = true;
      addToCartButton.innerText = 'Sold out';
    }
  }

  // Function to show/hide frequency label based on selling plans
  function updateFrequencyLabel(product) {
    if (product.selling_plan_groups.length > 0) {
      frequencyLabel.style.display = 'block';
      frequencySubheading.style.display = 'block';
      orderNowFormSubscription.style.display = 'block';
    } else {
      frequencyLabel.style.display = 'none';
      frequencySubheading.style.display = 'none';
      orderNowFormSubscription.style.display = 'none';
    }
  }

  // Function to update the progress bar steps
  function updateProgressBar(step) {
    progressBarSteps.forEach(function (progressStep) {
      let stepNumber = parseInt(progressStep.getAttribute('data-step'));
      if (stepNumber < step) {
        progressStep.classList.add('completed');
        progressStep.classList.remove('active');
      } else if (stepNumber === step) {
        progressStep.classList.add('active');
        progressStep.classList.remove('completed');
      } else {
        progressStep.classList.remove('active', 'completed');
      }
    });
  }

  // Function to update Yotpo widget instance
  function updateYotpoWidget(variant) {
    // console.log(variant);
    const orderNowForm = document.getElementById('order-now-form');
    if (orderNowForm) {
      const variantInput = orderNowForm.querySelector('input[name="id"]');
      if (variantInput) {
        // Update the input value with the new variant ID
        variantInput.setAttribute('data-productid', selectedProductId);
        variantInput.value = variant.id;
      }
    }
  }

  function initYotpoWidget(product) {
    let widgetContainer = document.getElementById('order-now-form-subscription');
    widgetContainer.innerHTML = '';
    let yotpoWidget = document.createElement('div');

    // Set the class attribute
    yotpoWidget.className = 'yotpo-widget-instance';

    // Set the data attributes
    yotpoWidget.setAttribute('data-yotpo-instance-id', '377286');
    yotpoWidget.setAttribute('product-handle', product.handle);
    yotpoWidget.setAttribute('widget-type', 'SubscriptionsAddToCartWidget');
    yotpoWidget.setAttribute('storefront-theme', 'unknown');
    yotpoWidget.setAttribute('injection', 'auto');
    yotpoWidget.setAttribute('full-format-product-price', `$${product.price}`);

    // Append the element to a widget container
    widgetContainer.appendChild(yotpoWidget);
    window.yotpoWidgetsContainer?.initWidgets();
  }

  // Event listeners for month selector buttons
  document.getElementById('current-month-btn').addEventListener('click', function () {
    if (currentMonthProduct && selectedProductId !== currentMonthProduct.id) {
      populateMenuSelector(currentMonthProduct, currentMonthSeasonalProduct, 'current');
      displayVariants(currentMonthProduct.id, currentMonthProduct.variants[0].option1);
      updateProgressBar(1); // Move back to step 1 on month change
      initYotpoWidget(currentMonthProduct);
      updateFrequencyLabel(currentMonthProduct);
      removeActiveClass('month-btn');
      this.classList.add('active');
    }
  });

  document.getElementById('next-month-btn').addEventListener('click', function () {
    if (nextMonthProduct && selectedProductId !== nextMonthProduct.id) {
      populateMenuSelector(nextMonthProduct, nextMonthSeasonalProduct, 'next');
      displayVariants(nextMonthProduct.id, nextMonthProduct.variants[0].option1);
      updateProgressBar(1); // Move back to step 1 on month change
      initYotpoWidget(nextMonthProduct);
      updateFrequencyLabel(nextMonthProduct);
      removeActiveClass('month-btn');
      this.classList.add('active');
    }
  });

  // Initialize the page with default product and menu option
  initializePage();

  function handleAddToCart(event) {
  // PAGE MODE: do a native form submit so the theme won't open the drawer
  if (cartType === 'page') {
    event.preventDefault();

    // Ensure form points to /cart/add and will redirect to /cart
    addToCartForm.action = '/cart/add';
    addToCartForm.method = 'post';

    // Make sure the variant input reflects the current selection
    const idInput = addToCartForm.querySelector('input[name="id"]');
    if (idInput && selectedVariant) {
      idInput.value = selectedVariant.id;
      idInput.setAttribute('data-productid', selectedProductId);
    }

    // Remove purchase-option inputs and selling_plan if one-time is chosen (Yotpo)
    Array.from(addToCartForm.querySelectorAll('input[name]')).forEach((inp) => {
      const name = inp.getAttribute('name') || '';
      if (name.includes('purchase-option')) inp.remove();
    });
    const oneTimeRadio = addToCartForm.querySelector('input[type="radio"][value="one-time-purchase"]');
    if (oneTimeRadio && oneTimeRadio.checked) {
      Array.from(addToCartForm.querySelectorAll('input[name="selling_plan"]')).forEach((inp) => inp.remove());
    }

    // Ensure quantity exists
    let qty = addToCartForm.querySelector('input[name="quantity"]');
    if (!qty) {
      qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      qty.value = '1';
      addToCartForm.appendChild(qty);
    }

    // Server-side redirect to cart
    let rt = addToCartForm.querySelector('input[name="return_to"]');
    if (!rt) {
      rt = document.createElement('input');
      rt.type = 'hidden';
      rt.name = 'return_to';
      addToCartForm.appendChild(rt);
    }
    rt.value = '/cart';

    addToCartForm.submit();
    return; // stop here; no drawer
  }

  // DRAWER MODE (AJAX + sections refresh)
  event.preventDefault();
  updateProgressBar(4);

  const formData = new FormData(addToCartForm);
  const jsonData = Object.fromEntries(formData.entries());

  // Clean up inputs similar to your previous logic
  for (const key in jsonData) {
    if (key.includes('purchase-option')) delete jsonData[key];
  }
  const oneTime = document.querySelector('input[type="radio"][value="one-time-purchase"]');
  if (oneTime && oneTime.checked) delete jsonData.selling_plan;

  // Keep your sections reload for the order-now cart UI
  jsonData.sections = 'order-now-cart-section';
  jsonData.sections_url = '/pages/order-now';

  if (selectedVariant) {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const existingItem = cart.items.find(
          (item) =>
            item.variant_id === selectedVariant.id &&
            ((item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id) || '') ===
              (jsonData.selling_plan || '')
        );
        if (existingItem) {
          updateCartItem(`${existingItem.id}`, existingItem.quantity + 1);
        } else {
          addItemToCart(jsonData);
        }
      })
      .catch((err) => console.error('Error fetching cart:', err));
  }
}

  function addItemToCart(data) {
    isAddingFromOrderNow = true; // Set flag
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        // The theme:cart:added event will handle the behavior based on cart type
        // If drawer is enabled, it will open automatically
        // If drawer is disabled, the event listener will redirect to cart page
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        isAddingFromOrderNow = false; // Reset flag on error
      });
  }

  function updateCartItem(lineItemId, newQuantity) {
    isAddingFromOrderNow = true; // Set flag
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItemId,
        quantity: newQuantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Cart updates might not trigger theme:cart:added event
        // Handle based on cart type
        if (cartType === 'page') {
          window.location = '/cart';
        } else {
          // If drawer is enabled, open it
          if (window.theme && window.theme.cart && window.theme.cart.openCartDrawer) {
            window.theme.cart.openCartDrawer();
          } else {
            window.location = '/cart';
          }
        }
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
        isAddingFromOrderNow = false; // Reset flag on error
      });
  }

  function removeCartItem(lineItemId) {
    // Send AJAX request to Shopify API to remove item from cart
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        line: Number(lineItemId) - 1,
        quantity: 0,
        sections: 'order-now-cart-section',
        sections_url: '/pages/order-now',
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Cart updated:', data);
        // Update the cart UI here (e.g., reload cart items, update totals)
        document.getElementById('cart-contents').innerHTML = data.sections['order-now-cart-section']
          ? data.sections['order-now-cart-section']
          : '';

        document.querySelectorAll('.cart__item__remove').forEach((button) => {
          button.addEventListener('click', function (event) {
            event.preventDefault();
            const lineItemId = button.getAttribute('data-id');
            removeCartItem(lineItemId);
          });
        });

        if (window.innerWidth < 768) {
          const continueShoppingButton = document.getElementById('continue-shopping');
          continueShoppingButton.addEventListener('click', function (event) {
            event.preventDefault();
            cartPart.style.display = 'none';
            productPart.style.display = 'block';
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
        }
      })
      .catch((error) => {
        console.error('Error removing cart item:', error);
      });
  }

  // Keep progress bar and cart section sticky
  function toggleStickyProgressBar() {
    const orderNowSectionTop = orderNowSection.getBoundingClientRect().top;

    if (orderNowSectionTop <= 0) {
      progressBarContainer.classList.add('sticky');
    } else {
      progressBarContainer.classList.remove('sticky');
    }
  }
  window.addEventListener('scroll', toggleStickyProgressBar);

  // function toggleStickyCartSections() {
  //   if (window.innerWidth >= 768) {
  //     const cartPartTop = cartPart.getBoundingClientRect().top;
  //     const cartPartBottom = cartPart.getBoundingClientRect().bottom;
  //     const cartContentsTop = cartContents.getBoundingClientRect().top;
  //     const cartContentsBottom = cartContents.getBoundingClientRect().bottom;

  //     if (cartPartTop <= 190) {
  //       if (cartContentsBottom < cartPartBottom - 5 || cartContentsTop > 195) {
  //         cartContents.classList.add('sticky');
  //         cartContents.classList.remove('sticky-bottom');
  //       } else {
  //         cartContents.classList.remove('sticky');
  //         cartContents.classList.add('sticky-bottom');
  //       }
  //     } else {
  //       cartContents.classList.remove('sticky');
  //       cartContents.classList.remove('sticky-bottom');
  //     }
  //   }
  // }
  // window.addEventListener('scroll', function () {
  //   toggleStickyCartSections()
  // });

  function formatYotpoPrices() {
    const priceElements = document.querySelectorAll(
      '.yotpo-radio-container .yotpo-subscription-price-label-wrapper .yotpo-subscription-label-price'
    );

    priceElements.forEach((priceElement) => {
      const priceText = priceElement.textContent.trim(); // e.g., "$188,10" or "$209"
      const cleanedPrice = priceText.replace(',', '.').replace('$', '').trim();

      const priceValue = parseFloat(cleanedPrice);
      if (!isNaN(priceValue)) {
        priceElement.textContent = `$${priceValue.toFixed(2)}`;
      }
    });
  }

  // Run every 2 seconds (adjust as needed)
  setInterval(formatYotpoPrices, 200);
});
